export default "__VITE_ASSET__DNk62PPN__"